/**
 * Typed reads off a registry payload (GDN-2723).
 *
 * The Resource Access detail route returns each type's record as loose JSON —
 * it serializes whatever the canonical read handed back, so there is no
 * generated type to lean on. These keep slot components honest about that
 * rather than casting the whole row to a hand-written interface that drifts
 * from the backend model.
 */

import type { ResourceRow } from './types';

export function str(row: ResourceRow, key: string): string | undefined {
  const value = row[key];
  return typeof value === 'string' && value !== '' ? value : undefined;
}

export function num(row: ResourceRow, key: string): number | undefined {
  const value = row[key];
  return typeof value === 'number' ? value : undefined;
}

export function bool(row: ResourceRow, key: string): boolean | undefined {
  const value = row[key];
  return typeof value === 'boolean' ? value : undefined;
}

export function list(row: ResourceRow, key: string): ResourceRow[] {
  const value = row[key];
  return Array.isArray(value) ? (value as ResourceRow[]) : [];
}

/** Status-ish strings render better as "No show" than "no_show". */
export function humanizeValue(value: string): string {
  const spaced = value.replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
